// import React, { createContext, useContext, useEffect, useRef, useState } from "react";
// import { fetchUserFromRedis } from "../../src/Components/AuthonticationPages/Register"; 

// const UserContext = createContext(null);

// export function UserProvider({ children }) {
//   const [user,    setUser]    = useState(null);
//   const [loading, setLoading] = useState(true);
//   const fetchedRef = useRef(false);

//   useEffect(() => {
//     if (fetchedRef.current) return;
//     fetchedRef.current = true;

//     const loadUser = async () => {
//       try {
//         // Step 1: show cached user instantly (no loading flash)
//         const stored = sessionStorage.getItem("user");
//         console.log("UserContext: stored user =", stored);
//         if (stored) {
//           setUser(JSON.parse(stored));
//           setLoading(false);
//         }

//         // Step 2: fetch fresh from Redis
//         const userId = sessionStorage.getItem("userId");
//         const token  = sessionStorage.getItem("token");
//         if (!userId || !token) { setLoading(false); return; }

//         const userData = await fetchUserFromRedis(userId, token);
//         if (userData) {
//           setUser(userData);
//           sessionStorage.setItem("user", JSON.stringify(userData));
//         }
//       } catch (err) {
//         console.error("UserContext: failed to fetch user", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadUser();
//   }, []);

//   return (
//     <UserContext.Provider value={{ user, loading, setUser }}>
//       {children}
//     </UserContext.Provider>
//   );
// }

// export function useUser() {
//   return useContext(UserContext);
// }


import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { fetchUserFromRedis } from "../Components/AuthonticationPages/Register";

const UserContext = createContext(null);

export function UserProvider({ children }) {

  // ── Initialize user SYNCHRONOUSLY from sessionStorage ──────────────────
  // This runs before first render, so there is NO blank flash or loading delay
  const [user, setUser] = useState(() => {
    try {
      const stored = sessionStorage.getItem("user");
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && (parsed.role || parsed.email)) {
          console.log("UserContext: sync init from sessionStorage, role =", parsed.role);
          return parsed;
        }
      }
    } catch { }
    return null;
  });

  // loading is false immediately if we got user from sessionStorage
  const [loading, setLoading] = useState(() => {
    try {
      const stored = sessionStorage.getItem("user");
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && (parsed.role || parsed.email)) return false;
      }
    } catch { }
    // No cached user — we'll need to fetch
    const userId = sessionStorage.getItem("userId");
    const token  = sessionStorage.getItem("token");
    return !!(userId && token);
  });

  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const userId = sessionStorage.getItem("userId");
    const token  = sessionStorage.getItem("token");

    if (!userId || !token) {
      setLoading(false);
      return;
    }

    // Refresh from Redis in background
    const refreshFromRedis = async () => {
      try {
        const userData = await fetchUserFromRedis(userId, token);
        if (userData) {
          setUser(userData);
          sessionStorage.setItem("user", JSON.stringify(userData));
          console.log("UserContext: refreshed from Redis, role =", userData.role);
        }
      } catch (err) {
        console.error("UserContext: Redis fetch failed", err);
      } finally {
        setLoading(false);
      }
    };

    refreshFromRedis();
  }, []);

  // ── updateUser: call this from Login.jsx after successful login ──────────
  const updateUser = (userData) => {
    console.log("UserContext: updateUser called, role =", userData?.role);
    setUser(userData);
    if (userData) {
      sessionStorage.setItem("user", JSON.stringify(userData));
    }
  };

  return (
    <UserContext.Provider value={{ user, loading, setUser, updateUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const ctx = useContext(UserContext);
  if (!ctx) return { user: null, loading: false, setUser: () => {}, updateUser: () => {} };
  return ctx;
}